import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';

import '../style.scss';
import { EntityId } from "@reduxjs/toolkit";
import Card from "../../../mine_craft/UsernameStyles/_partials/_Card";
import { selectUsernameStyleEntities, selectUsernameStyleIds } from "../../../../store/mine_craft/usernameStylesSlice";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
  pagination: boolean;
}

const _List = ({ limit, pagination }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.usernameStyles.count);
  const error  = useAppSelector(state => state.mineCraft.usernameStyles.error);
  const status = useAppSelector(state => state.mineCraft.usernameStyles.status);
  const ids = useAppSelector(selectUsernameStyleIds);
  const usernameStyles = useAppSelector(selectUsernameStyleEntities);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  const renderUsernameStyle = (id: EntityId) => {
    const usernameStyle = usernameStyles[id];

    if (!usernameStyle) {
      return;
    }

    return <Card usernameStyle={usernameStyle} key={`usernameStyle-${id}`} />;
  }

  return (
    <>
      {ids && ids.map(renderUsernameStyle)}

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
